<template>
    <div id="deviceName">
        <div>{{infoText}}</div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            infoText: '上蔬源 KSH-01',
        }
    },
    components: {

    },
    mounted() {
        
    },
    beforeDestroy () {

    },
    methods: {
        
    }
}

</script>
<style lang="scss" scoped>

#deviceName {
    width:70%;
    margin:10px auto;
    margin-top:10px;
    color: #d3d7f7;
    font-size: 18px;
    text-align: center;

    .saveBtn {
        padding:15px 20px;
        border:1px solid #257dff;
    }

    .content-box {
        width:100%;
        display:flex;
        flex-direction:row;
        flex-wrap:wrap;
    }

    .item {
        display:flex;
        flex-direction:row;
        justify-content:center;
        align-items:center;
        margin:15px 20px;
    }

    input {
        width:200px;
        height:35px;
        text-align: center;
        border: 1px solid #257dff;
        background-color:rgba(0,0,0,0);
        font-size: 18px;
        color:rgb(0, 186, 255);
    }
    
    span {
        margin-left:10px;
    }

    .fun-tip {
        position:absolute;
        left:45%;
        bottom:80px;
        padding:15px 50px;
        background-color: rgba(19, 25, 47, 0.6);
        border:2px solid rgb(46, 96, 153);
        border-radius:12px;
    }
}

</style>
